import { Component, OnInit } from '@angular/core';
import { BusinessUser } from 'src/app/models/business-user.model';
import { AuthService } from 'src/app/services/auth.service';
import { MgService } from 'src/app/services/mg.service';

@Component({
  selector: 'app-client-home',
  templateUrl: './client-home.component.html',
  styleUrls: ['./client-home.component.scss']
})
export class ClientHomeComponent implements OnInit {
  public usage: any = null;

  constructor(
    private api: MgService,
    private userService: AuthService
  ) { }

  ngOnInit(): void {
    this.api.loadBusinessUserUsage()
      .toPromise()
      .then((res) => {
        this.usage = res;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  get user(): BusinessUser {
    return this.userService.user;
  }
}
